import { render, staticRenderFns } from "./Prediction.vue?vue&type=template&id=1e29db27&scoped=true"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e29db27",
  null
  
)

export default component.exports